import { render } from "./VisualizedTotalStar.vue?vue&type=template&id=82526ee0&scoped=true"
import script from "./VisualizedTotalStar.vue?vue&type=script&lang=js"
export * from "./VisualizedTotalStar.vue?vue&type=script&lang=js"

import "./VisualizedTotalStar.vue?vue&type=style&index=0&id=82526ee0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82526ee0"]])

export default __exports__